import React, { useEffect, useState } from 'react';
import './App.css';
import ConfigPanel from './components/ConfigPanel';
import ReceiptSheet from './components/ReceiptSheet';
import { STORAGE_KEY, createEmptyRow, loadSettings } from './utils/settings';

const ReceiptPage = () => {
  const [initialSettings] = useState(loadSettings);
  const [sellerName, setSellerName] = useState(initialSettings.sellerName);
  const [ico, setIco] = useState(initialSettings.ico);
  const [dic, setDic] = useState(initialSettings.dic);
  const [address, setAddress] = useState(initialSettings.address);
  const [saleDate, setSaleDate] = useState(initialSettings.saleDate);
  const [rowCount, setRowCount] = useState(initialSettings.rowCount);
  const [receiptCount, setReceiptCount] = useState(initialSettings.receiptCount);
  const [columnsCount, setColumnsCount] = useState(initialSettings.columnsCount);
  const [scale, setScale] = useState(initialSettings.scale);
  const [showRowEditor, setShowRowEditor] = useState(false);
  const [showBorders, setShowBorders] = useState(initialSettings.showBorders);
  const [showCuttingLines, setShowCuttingLines] = useState(initialSettings.showCuttingLines);
  const [rowsData, setRowsData] = useState(initialSettings.rowsData);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
      sellerName,
      ico,
      dic,
      address,
      saleDate,
      rowCount,
      receiptCount,
      columnsCount,
      scale,
      showBorders,
      showCuttingLines,
      rowsData
    }));
  }, [
    sellerName,
    ico,
    dic,
    address,
    saleDate,
    rowCount,
    receiptCount,
    columnsCount,
    scale,
    showBorders,
    showCuttingLines,
    rowsData
  ]);

  const handlePrint = () => {
    window.print();
  };

  const handleScaleChange = (event) => {
    setScale(parseFloat(event.target.value));
  };

  const handleRowCountChange = (event) => {
    const count = parseInt(event.target.value, 10);
    setRowCount(count);

    setRowsData((currentRows) => {
      if (count <= currentRows.length) return currentRows;

      const newRows = Array.from({ length: count - currentRows.length }, createEmptyRow);
      return [...currentRows, ...newRows];
    });
  };

  const handleRowChange = (index, field, value) => {
    setRowsData((currentRows) => {
      const nextRows = [...currentRows];
      nextRows[index] = {
        ...(nextRows[index] || createEmptyRow()),
        [field]: value
      };
      return nextRows;
    });
  };

  return (
    <div className="app-container">
      <ConfigPanel
        sellerName={sellerName}
        ico={ico}
        dic={dic}
        address={address}
        saleDate={saleDate}
        rowCount={rowCount}
        receiptCount={receiptCount}
        columnsCount={columnsCount}
        scale={scale}
        showBorders={showBorders}
        showCuttingLines={showCuttingLines}
        showRowEditor={showRowEditor}
        rowsData={rowsData}
        onSellerNameChange={setSellerName}
        onIcoChange={setIco}
        onDicChange={setDic}
        onAddressChange={setAddress}
        onSaleDateChange={setSaleDate}
        onRowCountChange={handleRowCountChange}
        onReceiptCountChange={setReceiptCount}
        onColumnsCountChange={setColumnsCount}
        onScaleChange={handleScaleChange}
        onShowBordersChange={setShowBorders}
        onShowCuttingLinesChange={setShowCuttingLines}
        onToggleRowEditor={() => setShowRowEditor((isShown) => !isShown)}
        onRowChange={handleRowChange}
        onPrint={handlePrint}
      />

      <ReceiptSheet
        scale={scale}
        showCuttingLines={showCuttingLines}
        columnsCount={columnsCount}
        receiptCount={receiptCount}
        rowCount={rowCount}
        sellerName={sellerName}
        ico={ico}
        dic={dic}
        address={address}
        saleDate={saleDate}
        rowsData={rowsData}
        showBorders={showBorders}
      />
    </div>
  );
};

export default ReceiptPage;
